import { createCtx } from '../createCtx';
import { UserReportingPeriodState, WorkDay } from '../../../api/generated/data-contracts';

export type ReportPeriod = {
    periodId: string;
    name: string;
    state: UserReportingPeriodState;
    reportPeriodId: string;
    startDate: Date;
    endDate: Date;
    isClosed: boolean;
    deadlineDate: Date;
    workDays: WorkDay[];
    nextPeriodStartDate: Date;
};

export type GridContext = {
    cellsWithError: string[];
    setCellsWithError: React.Dispatch<React.SetStateAction<string[]>>;
    selectedTimePeriod: ReportPeriod | null;
    setSelectedTimePeriod: React.Dispatch<React.SetStateAction<ReportPeriod | null>>;
    splitBarPos: number;
    setSplitBarPos: React.Dispatch<React.SetStateAction<number>>;
    plannedActive: boolean;
    setPlannedActive: React.Dispatch<React.SetStateAction<boolean>>;
    actualActive: boolean;
    setActualActive: React.Dispatch<React.SetStateAction<boolean>>;
    remainingActive: boolean;
    setRemainingActive: React.Dispatch<React.SetStateAction<boolean>>;
    latestModifiedDelegateUserIds: string[];
    setLatestModifiedDelegateUserIds: React.Dispatch<React.SetStateAction<string[]>>;
};

export const [useGridContext, Provider] = createCtx<GridContext>();
